module.exports = __webpack_public_path__ + "/img/crveni.ff27e296.png";